import { create } from 'zustand'
import { immer } from "zustand/middleware/immer";

export const useV4Storage = create(immer(set => ({
    dados: {
        activeGroup: {},
    },
    dispatch: {
        setActivegGroup: (payload) => set(state => {
            state.dados.activeGroup = payload
        }),
    }
})))
